"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Button_1 = require("@Components/Buttons/Button");
const contexts_1 = require("@App/contexts");
const writer_form_type_1 = require("@App/enum/writer-form-type");
const SearchResult_1 = __importDefault(require("@Components/WorkRegistrationSubs/SearchResult"));
const validate_1 = require("@App/helpers/validate");
const WriterAfterFindForm = ({ changeFormTo, setFoundWriterToDraft, addWriterToDraft }) => {
    const { writerSearchStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const searchResult = writerSearchStore.writersSearchModel;
    const searchResultTitle = (writerSearchResults) => `${writerSearchResults.entity.firstName} ${writerSearchResults.entity.lastName}`;
    const isValidIPI = (ipiNumber) => (ipiNumber ? (0, validate_1.IPIValidator)(ipiNumber, true) : true);
    const writerRoles = (writerSearchResults) => {
        if (writerSearchResults.entity.ipiNumber && isValidIPI(writerSearchResults.entity.ipiNumber)) {
            return [{ name: 'IPI Number', value: writerSearchResults.entity.ipiNumber }];
        }
        return [];
    };
    (0, react_1.useEffect)(() => () => {
        writerSearchStore.clearStore();
    }, []);
    return (react_1.default.createElement("div", { className: "writer-sub-form-component" },
        react_1.default.createElement("h2", null, searchResult && searchResult.results.length > 1
            ? 'We already have writers with those details:'
            : 'We already have a writer with those details:'),
        writerSearchStore.isThereSearchResults && (react_1.default.createElement("div", { className: 'suggested' }, searchResult === null || searchResult === void 0 ? void 0 : searchResult.results.map((data) => (react_1.default.createElement(SearchResult_1.default, { key: data.entity.id, title: searchResultTitle(data), onAddClicked: () => setFoundWriterToDraft(data.entity), onItemWasAdded: () => false, roles: writerRoles(data) }))))),
        react_1.default.createElement("p", { className: 'cant-find-title-after-find' }, "Not the correct writer?"),
        react_1.default.createElement("div", { className: "buttons-area" },
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: () => changeFormTo(writer_form_type_1.WriterFormType.create) }, "Back to create"),
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: addWriterToDraft }, "Confirm & create new"))));
};
exports.default = WriterAfterFindForm;
